<template>
  <button
    type="button"
    class="box"
    :class="[{ selected: props.isActive }, `colors-${props.colors}`]"
  >
    <div class="top">
      <div class="title">
        <img :src="props.icon" width="20" height="20" />
        <div class="title-tag" v-html="props.label"></div>
      </div>
      <DeployerUiFormRadioButton :is-checked="props.isActive" />
    </div>
    <div class="text" v-html="props.text"></div>
  </button>
</template>

<script setup>
const props = defineProps({
  icon: String,
  label: String,
  text: String,
  isActive: Boolean,
  colors: {
    type: String,
    default: 'standard'
  }
})
</script>

<style lang="scss" scoped>
.box {
  border-radius: 10px;
  border: 1px solid var(--field-stroke, rgba(0, 0, 0, 0.2));
  background: var(--field-bg, #fff);
  padding: 20px;
  min-height: 130px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  transition: border 0.2s, box-shadow 0.2s;
  color: var(--Text, #000);

  &.selected {
    border: 1px solid #31a3fe;
    box-shadow: 0px 0px 5px 0px rgba(80, 79, 228, 0.5);
  }

  &:hover {
    box-shadow: 0px 0px 5px 0px rgba(80, 79, 228, 0.5);
  }
}

.title {
  display: flex;
  align-items: center;
  gap: 4px;
}
.title-tag {
  padding: 5px;
  line-height: 100%;
  border-radius: 5px;
  font-weight: 500;

  .colors-standard & {
    background: rgba(123, 63, 228, 0.2);
    color: #7b3fe4;
  }

  .colors-gray & {
    background: rgba(128, 128, 128, 0.2);
    color: #808080;
  }
}

.top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.text {
  font-size: 1.3rem;
  line-height: 150%;
  letter-spacing: 0.13px;
  opacity: 0.7;
  margin-bottom: 20px;
}
</style>
